import { getToken } from "../utils/storage/Token";
import {
    useGetRequest,
    RequestResponse,
    PostRequest,
    PatchRequest,
    DeleteRequest,
    RequestPromise,
} from "../hook/useRequest";

export interface IApiKeyInfo {
    id: number;
    name: string;
    keyPrefix: string;
    isActive: boolean;
    createdAt: string;
    lastUsedAt: string | null;
}

export interface IApiKeyCreated {
    id: number;
    name: string;
    keyPrefix: string;
    rawKey: string;
    createdAt: string;
}

const useFetchApiKeys = (id_user: number, forceUpdated = 0): RequestResponse<IApiKeyInfo[]> => {
    const config = { headers: { Authorization: getToken() } };
    return useGetRequest<IApiKeyInfo[]>(`/fl/apikeys/${id_user}`, forceUpdated, config);
};

const CreateApiKey = (id_user: number, name: string): RequestPromise<IApiKeyCreated> => {
    const config = { headers: { Authorization: getToken() } };
    return PostRequest<IApiKeyCreated>(`/fl/apikeys/${id_user}`, { name }, config);
};

const RevokeApiKey = (id_user: number, id_key: number): RequestPromise<void> => {
    const config = { headers: { Authorization: getToken() } };
    return PatchRequest<void>(`/fl/apikeys/${id_user}/revoke/${id_key}`, {}, config);
};

const DeleteApiKey = (id_user: number, id_key: number): RequestPromise<void> => {
    const config = { headers: { Authorization: getToken() } };
    return DeleteRequest<void>(`/fl/apikeys/${id_user}/${id_key}`, config);
};

export { useFetchApiKeys, CreateApiKey, RevokeApiKey, DeleteApiKey };
